var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullfolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.351,
    height: 171.095,
    viewBox: "0 0 169.351 171.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f69730;}.b{fill:#fff;}.c{fill:#7dc133;}.d{fill:#a7a9ac;}.e{fill:#ffc200;}.f{fill:#f20000;}.g{fill:#ffb82b;}.h{fill:#28a745;}.i{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 39.457,
    y: 0,
    width: 125.692,
    height: 149.647,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#303030",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-857.271 -169.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(857.271 177.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-662.339,358.815v-3.607a5.65,5.65,0,0,0-5.4-5.87h-56.3a5.65,5.65,0,0,0-5.4,5.87l15.952,107.754,110.838-1.905,7.405-97.982a5.65,5.65,0,0,0-5.4-5.87Z",
    transform: "translate(729.437 -349.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H122.606V96.468H14.7Z",
    transform: "translate(6.477 16.325)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.457 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -51.46, -8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H100.759V124.894H0Z",
    transform: "matrix(1, -0.01, 0.01, 1, 51.46, 8.75)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.718 13.185)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.297 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1085.688,140.277l-28.244.21a.538.538,0,0,1-.544-.532h0a.539.539,0,0,1,.532-.545l28.244-.21a.539.539,0,0,1,.545.532h0A.531.531,0,0,1,1085.688,140.277Z",
    transform: "translate(-1056.9 -139.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1086.089,199.777l-28.244.21a.539.539,0,0,1-.544-.532h0a.539.539,0,0,1,.532-.545l28.244-.21a.539.539,0,0,1,.544.532h0A.531.531,0,0,1,1086.089,199.777Z",
    transform: "translate(-1057.25 -193.946)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1003.273,286.347l-19.494.149a.782.782,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l19.494-.148a.774.774,0,0,1,.78.767h0A.767.767,0,0,1,1003.273,286.347Z",
    transform: "translate(-938.047 -266.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1198.272,285.247l-11.993.087a.782.782,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l11.993-.087a.774.774,0,0,1,.78.767h0A.774.774,0,0,1,1198.272,285.247Z",
    transform: "translate(-1115.484 -265.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M659.736,287.947l-37.056.272a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.768-.78l37.056-.272a.774.774,0,0,1,.78.767h0A.774.774,0,0,1,659.736,287.947Z",
    transform: "translate(-621.64 -268.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M652.931,331.647l-29.952.223a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l29.952-.223a.774.774,0,0,1,.78.767h0A.782.782,0,0,1,652.931,331.647Z",
    transform: "translate(-621.903 -306.473)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M935.032,329.547l-29.952.223a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78L935.019,328a.774.774,0,0,1,.78.767h0A.79.79,0,0,1,935.032,329.547Z",
    transform: "translate(-869.088 -304.633)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 33.801)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1001.273,414.859,981.78,415a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l19.493-.149a.774.774,0,0,1,.78.767h0A.793.793,0,0,1,1001.273,414.859Z",
    transform: "translate(-936.295 -413.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1196.272,413.847l-11.993.087a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l11.993-.087a.774.774,0,0,1,.78.767h0A.774.774,0,0,1,1196.272,413.847Z",
    transform: "translate(-1113.732 -412.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M657.636,416.547l-37.056.272a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78L657.623,415a.774.774,0,0,1,.78.767h0A.766.766,0,0,1,657.636,416.547Z",
    transform: "translate(-619.8 -414.666)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M650.932,460.147l-29.952.223a.774.774,0,0,1-.78-.767h0a.782.782,0,0,1,.767-.78l29.952-.223a.774.774,0,0,1,.78.767h0A.774.774,0,0,1,650.932,460.147Z",
    transform: "translate(-620.151 -452.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M640.728,460.147l-20.007.223c-.289,0-.521-.346-.521-.767h0c0-.421.231-.78.513-.78l20.007-.223c.289,0,.521.347.521.767h0C641.24,459.8,641.009,460.147,640.728,460.147Z",
    transform: "translate(-575.494 -452.869)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.087 45.175)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1001.973,506.747l-19.493.149a.774.774,0,0,1-.78-.768h0a.774.774,0,0,1,.767-.78l19.494-.148a.774.774,0,0,1,.779.767h0A.774.774,0,0,1,1001.973,506.747Z",
    transform: "translate(-936.995 -505.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1196.973,505.747l-11.993.087a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l11.993-.087a.774.774,0,0,1,.78.767h0A.79.79,0,0,1,1196.973,505.747Z",
    transform: "translate(-1114.432 -504.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M651.409,508.447l-30.272.272a.712.712,0,0,1-.637-.767h0a.716.716,0,0,1,.627-.78L651.4,506.9a.712.712,0,0,1,.637.768h0A.718.718,0,0,1,651.409,508.447Z",
    transform: "translate(-620.5 -506.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M651.532,552.047l-29.952.223a.774.774,0,0,1-.78-.767h0a.774.774,0,0,1,.767-.78l29.952-.223a.774.774,0,0,1,.78.767h0A.759.759,0,0,1,651.532,552.047Z",
    transform: "translate(-620.763 -544.77)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-653.391,454.01l-2.324,6h-67.423a6.1,6.1,0,0,0-6.3,5.87l8.639,74.736a6.1,6.1,0,0,0,6.3,5.87h126.68a6.1,6.1,0,0,0,6.3-5.87L-572.88,456a6.1,6.1,0,0,0-6.3-5.87h-68.287A6.292,6.292,0,0,0-653.391,454.01Z",
    transform: "translate(738.293 -400.841)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(983.234 297.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 21.694,
    cy: 21.694,
    r: 21.694,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.392,13.752,1.848,8.307,0,10.12l7.392,7.264L23.23,1.818,21.382,0Z",
    transform: "translate(10.03 12.798)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullfolder);
export default __webpack_public_path__ + "static/media/fullfolder.9c0b6659dcf52ceed580f8ac834ed051.svg";
export { ForwardRef as ReactComponent };